<template>
  <div>
    <MasterLayout>
      <div class="dashboard_first_row">
        <div class="buttons_section">
          <div>
            <vue-ctk-date-time-picker
              v-model="dateRange"
              :max-date="maxDate"
              :range="true"
              :autoClose="true"
              :custom-shortcuts="customShortcuts"
              color="#4b2c72"
              format="DDMMYYYY"
              formatted="DD/MM/YYYY"
              :label="$t('text.calendar.dateRange')"
            />
          </div>

          <!-- select branch -->
          <!-- <div class="pos_select_branch">
            <select class="btn details_btn px-3 mr-3 mt-2" v-model="branchId">
              <option disabled value="selectABranch">
                {{ $t("text.cBank.selectStation") }}
              </option>
              <option value="showAll">{{ $t("text.cBank.showAll") }}</option>
              <option
                v-for="(branch, index) in branches"
                :key="index"
                v-bind:value="branch.id"
              >
                {{ branch.name }}
              </option>
            </select>
          </div> -->
          <!--  -->

          <!-- select vendors -->
          <div class="pos_select_branch">
            <select class="btn details_btn px-3 mr-3 mt-2" v-model="vendor">
              <option disabled value="selectVendor">
                {{ $t("text.posRevamp.selectVendor") }}
              </option>
              <option value="">{{ $t("text.cBank.showAll") }}</option>
              <option
                v-for="(vendor, index) in vendors"
                :key="index"
                v-bind:value="vendor"
              >
                {{ vendor }}
              </option>
            </select>
          </div>
          <!--  -->
          <div class="pos_select_branch">
            <select class="btn details_btn px-3 mr-3 mt-2" v-model="status">
              <option disabled value="selectAStatus">
                {{ $t("text.cBank.selectStatus") }}
              </option>
              <option value="">{{ $t("text.cBank.showAll") }}</option>
              <option value="00">{{ $t("text.cBank.approve") }}</option>
              <option value="0x0x0">{{ $t("text.cBank.declined") }}</option>
            </select>
          </div>
        </div>
        <div class="row mt-3 pos_trans_card_holder">
          <div class="col-lg-4 col-md-4 remove_padding-right pos_trans_card">
            <div class="card_container_1 shadow-sm pos-card mt-3">
              <p class="dashboard__card__header text-uppercase text-center">
                {{ $t("text.cBank.successTrans") }}
              </p>
              <div class="icon_wrapper inner_border_radius mx-auto">
                <img src="@/assets/img/credit-card (2).svg" width="40px" />
              </div>
              <div class="mt-3 text-center">
                <h3 class="font-weight-bold">
                  {{ company ? company.currencyCode : "" }}
                  {{ totalSuccessfulTransactionsAmount }}
                </h3>
                <small
                  class="dashboard__card__header_bottom font-weight-bold"
                  >{{ totalSuccessfulTransactions }}</small
                >
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 remove_padding-right pos_trans_card">
            <div class="card_container_1 shadow-sm pos-card mt-3">
              <p class="dashboard__card__header text-uppercase text-center">
                {{ $t("text.cBank.failedTrans") }}
              </p>
              <div class="icon_wrapper inner_border_radius mx-auto">
                <img src="@/assets/img/credit-card (3).svg" width="40px" />
              </div>
              <div class="mt-3 text-center">
                <h3 class="font-weight-bold">
                  {{ company ? company.currencyCode : "" }}
                  {{ totalFailedTransactionsAmount }}
                </h3>
                <small
                  class="dashboard__card__header_bottom font-weight-bold"
                  >{{ totalFailedTransactions }}</small
                >
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 remove_padding-right pos_trans_card">
            <div class="card_container_1 shadow-sm pos-card mt-3">
              <p class="dashboard__card__header text-uppercase text-center">
                {{ $t("text.cBank.totalTransactions") }}
              </p>
              <div class="icon_wrapper inner_border_radius mx-auto">
                <img src="@/assets/img/credit-card (4).svg" width="40px" />
              </div>
              <div class="mt-3 text-center">
                <h3 class="font-weight-bold">
                  {{ company ? company.currencyCode : "" }}
                  {{ totalTransactionsAmount }}
                </h3>
                <small class="dashboard__card__header_bottom font-weight-bold">
                  {{ totalTransactions }}
                </small>
              </div>
            </div>
          </div>

          <!-- <div class="col-lg-4 col-md-4 remove_padding-right pos_trans_card">
            <div class="card_container_1 shadow-sm pos-card mt-3">
              <p class="dashboard__card__header text-uppercase text-center">
                {{ $t("text.cBank.transaction.totalBalance") }}
              </p>
              <div class="icon_wrapper inner_border_radius mx-auto">
                <img src="@/assets/img/credit-card (6).svg" width="40px" />
              </div>
              <div class="mt-3 text-center">
                <h3 class="font-weight-bold">
                  {{ company ? company.currencyCode : "" }} {{ companyBalance }}
                </h3>
              </div>
            </div>
          </div> -->
        </div>
      </div>

      <!-- Settlement button -->
      <!-- <section class="d-flex justify-content-end">
        <div>
          <button
            class="ep-btn ep-primary mr-2 px-5"
            style="border-radius: 4px"
            @click="openSettlementModal"
          >
            {{ $t("text.bSettlement.settlement") }}
          </button>
        </div>
      </section> -->
      <!--  -->

      <section>
        <div class="pos_table">
          <div class="row top_section_row" v-show="!showLoader">
            <div class="col-md-8">
              <span class="sec_text_color">
                {{ $t("text.cBank.posTerminal.between") }}
                {{ $route.query.startDate }} -
                {{ $route.query.endDate }}
              </span>
              <span> </span>
            </div>

            <div
              v-show="!showLoader"
              class="col-md-4 d-flex align-items-center"
            >
              <button class="btn btn-light mr-3" @click="getTransactions">
                <img src="@/assets/img/refresh.svg" />
              </button>

              <button
                class="btn btn-light mr-3"
                :class="{
                  disabled: !previousToken || showLoader,
                  'cursor-not-allowed': !previousToken || showLoader,
                }"
                @click="handlePreviousPage"
                :disabled="!previousToken || showLoader"
              >
                <img src="@/assets/img/arrowLeft.png" />
              </button>

              <p class="mb-0 mr-3 text-muted">
                {{ $t("text.actionButtons.page") }} {{ pages }}
              </p>

              <button
                class="btn btn-light"
                :class="{
                  disabled: !continuationToken || showLoader,
                  'cursor-not-allowed': !continuationToken || showLoader,
                }"
                @click="handleNextPage"
                :disabled="!continuationToken || showLoader"
              >
                <img src="@/assets/img/arrowRight.png" />
              </button>
            </div>
          </div>

          <ejs-grid
            v-show="!showLoader"
            ref="dataGrid"
            :created="refreshGrid"
            :allowPaging="false"
            :allowSorting="true"
            :toolbar="toolbar"
            :pageSettings="pageSettings"
            :searchSettings="search"
            :allowExcelExport="true"
            :allowPdfExport="true"
            :toolbarClick="toolbarClick"
            :rowDataBound="rowDataBound"
            :allowTextWrap="true"
            :excelQueryCellInfo="excelQueryCellInfo"
            :locale="usedLang"
            :rowSelected="rowSelected"
          >
            <e-columns>
              <e-column
                width="80"
                field="index"
                :allowSorting="false"
                headerText="#"
              ></e-column>
              <e-column
                field="paymentDate"
                :format="formatOptions"
                type="date"
                width="200"
                :headerText="$t('text.cBank.posTerminal.transactionDate')"
              ></e-column>
              <e-column
                :visible="!branchSelected"
                field="branchName"
                width="180"
                :headerText="$t('text.cBank.station')"
              ></e-column>
              <e-column
                field="pumpName"
                width="100"
                :headerText="$t('text.cBank.posTerminal.pump')"
              ></e-column>
              <e-column
                field="amount"
                width="150"
                format="N2"
                :headerText="`${$t('text.cBank.amount')} (${
                  company ? company.currency : ''
                })`"
              ></e-column>

              <!-- <e-column field="stan" width="220" headerText="Stan"></e-column> -->

              <!-- <e-column
                field="retrievalReferenceNumber"
                width="220"
                :headerText="$t('text.bPos.rrn')"
              ></e-column> -->

              <!-- <e-column
                field="maskedPan"
                width="220"
                :headerText="$t('text.cBank.posTerminal.maskedPan')"
              ></e-column> -->

              <e-column
                field="statusDescription"
                width="200"
                :headerText="$t('text.cBank.status')"
              ></e-column>

              <!-- Action button -->
              <!-- <e-column
                width="180"
                :template="actionTemplate"
                :headerText="$t('text.cBank.action')"
              ></e-column> -->
            </e-columns>
          </ejs-grid>
        </div>

        <TableLoader :showLoader="showLoader" />
      </section>
    </MasterLayout>
    <POSModal :modalData="modalData"></POSModal>
    <!-- <CompanyPOSettlement
      :company="company"
      :settlementAcct="settlementAcct"
    ></CompanyPOSettlement> -->
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Company/MasterLayout.vue";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import POSModal from "@/components/modals/POS/index";
import CompanyPOSettlement from "@/components/modals/POS/CompanyPOSettlement";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "POS Transactions:: Epump Portal",
  name: "POS-Transactions",
  components: {
    MasterLayout,
    TableLoader,
    POSModal,
    CompanyPOSettlement,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  data() {
    return {
      sha512: require("js-sha512").sha512,
      appId: configObject.appId,
      sec_key: configObject.secKey,
      devEmail: configObject.devEmail,
      vendor: "selectVendor",
      vendors: [],

      companyBalance: 0,
      settlementAcct: null,
      usedLang: this.$store.getters.getLanguage,
      formatOptions: { type: "date", format: "dd/MM/yyyy" },
      branchSelected: false,
      // totalCharges: 0,
      // totalChargesCount: 0,
      branches: null,
      branchId: "selectABranch",
      status: "selectAStatus",
      company: null,
      terminalId: "",
      totalTransactions: 0,
      totalTransactionsAmount: 0,
      totalSuccessfulTransactions: 0,
      totalSuccessfulTransactionsAmount: 0,
      totalFailedTransactions: 0,
      totalFailedTransactionsAmount: 0,
      modalData: null,
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      startDate: this.$moment().subtract(7, "days").format("MMMM D, YYYY"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      pluginStartDate: this.$moment().subtract(7, "days").format("D-M-YYYY"),
      pluginEndDate: this.$moment().format("D-M-YYYY"),
      dateRange: { start: this.pluginStartDate, end: this.pluginEndDate },
      showLoader: true,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },

      continuationToken: "",
      previousToken: "",
      pages: 1,

      actionTemplate: function () {
        return {
          template: Vue.component("actionButtonsTemplate", {
            template: `<div class="btn dealers_btn mr-3" @click="showDetails(data)">
                        Details
                    </div>`,
            data: function () {
              return {
                data: {},
              };
            },
            methods: {
              showDetails(data) {
                this.$eventHub.$emit("showDetails", data);
              },
            },
          }),
        };
      },
    };
  },
  watch: {
    company(company) {
      if (company !== null) {
        this.getVendors();
        // this.getCompanyBalance();
        // this.getSettlementAcct();
      }
    },

    // branches(branches) {
    //   if (branches !== null) {
    //     this.getTransactions();
    //     this.getPOSSummary();
    //   }
    // },

    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );

        this.$router.replace({
          name: this.$route.name,
          query: {
            companyId: this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id,
            startDate: this.startDate,
            endDate: this.endDate,
          },
        });

        this.getTransactions();
        this.getPOSSummary();
      }
    },
    // branchId: function (newId, oldId) {
    //   if (newId !== null && newId !== "selectABranch") {
    //     this.getTransactions();
    //   }
    // },
    status: function (newStatus, oldStatus) {
      if (newStatus !== null && newStatus !== "selectAStatus") {
        this.getTransactions();
      }
    },

    vendor: function (newVendor, oldVendor) {
      if (newVendor !== null && newVendor !== "selectVendor") {
        this.getTransactions();
      }
    },
  },
  created() {
    this.$eventHub.$on("company", (company) => {
      this.company = company;
    });

    if (this.$route.query.companyId) {
      this.getVendors();
      this.getTransactions();
      this.getPOSSummary();
      // this.getCompanyBalance();
      // this.getSettlementAcct();
    }

    if (this.$route.query.startDate && this.$route.query.endDate) {
      this.dateRange.start = this.$moment(this.$route.query.startDate).format(
        "D-M-YYYY"
      );
      this.dateRange.end = this.$moment(this.$route.query.endDate).format(
        "D-M-YYYY"
      );
    } else {
      this.dateRange.start = this.pluginStartDate;
      this.dateRange.end = this.pluginEndDate;

      this.$router.replace({
        name: this.$route.name,
        query: {
          companyId: this.$route.query.companyId
            ? this.$route.query.companyId
            : this.company.id,
          startDate: this.$moment(this.pluginStartDate, "DD-MM-YYYY").format(
            "MMMM D, YYYY"
          ),
          endDate: this.$moment(this.pluginEndDate, "DD-MM-YYYY").format(
            "MMMM D, YYYY"
          ),
        },
      });
    }

    // this.dateRange.start = this.pluginStartDate;
    // this.dateRange.end = this.pluginEndDate;

    this.$eventHub.$on("showDetails", (data) => {
      this.modalData = data;
      this.$modal.show("POSModal");
    });
    this.$eventHub.$on("PrintPos", () => {
      this.printWithCSS();
    });

    this.$eventHub.$on("refreshTransaction", () => {
      this.getTransactions();
      this.getPOSSummary();
      // this.getCompanyBalance();
    });
  },
  beforeDestroy() {
    this.$eventHub.$off("showDetails");
  },
  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },

  methods: {
    //utilities
    rowSelected(args) {
      this.modalData = args.data;
      this.$modal.show("POSModal");
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    printWithCSS() {
      var elementHTML = $("#printContent").html();
      var myWindow = window.open("", "", "width=1000,height=700");
      myWindow.document.write(elementHTML);
      var style = myWindow.document.createElement("style");
      style.innerHTML = `
        @page {
          size: auto;  /* auto is the initial value */
          margin: 0mm; /* this affects the margin in the printer settings */
        }
        html {
          background-color: #FFFFFF;
          margin: 0px; /* this affects the margin on the HTML before sending to printer */
        }
        body {
          margin: 10mm 15mm 10mm 15mm; /* margin you want for the content */
          margin: 0mm;
          max-width:465px; 
          padding:15px 0px;
        }
        
        `;
      myWindow.document.head.appendChild(style);
      myWindow.document.close();
      myWindow.focus();
      myWindow.print();
      myWindow.close();
    },

    excelQueryCellInfo(args) {
      if (args.column.field == "paymentDate") {
        args.value = this.$moment(args.value).format("DD/MM/YYYY");
      }
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          let pdfExportProperties = {
            pageOrientation: "Landscape",
            fileName: "POS Transactions.pdf",
          };
          this.$refs.dataGrid.pdfExport(pdfExportProperties);
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    rowDataBound: function (args) {
      if (args.data["statusCode"] === "00") {
        args.row.cells[5].style.color = "green";
      } else {
        args.row.cells[5].style.color = "red";
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },

    //modals

    openSettlementModal() {
      this.$modal.show("CompanyPOSettlement");
    },

    //requests

    getSettlementAcct() {
      let url = `${configObject.apiBaseUrl}/Company/SettlementBankAccount/${
        this.$route.query.companyId
          ? this.$route.query.companyId
          : this.company.id
      }?AccountType=POS`;

      this.axios
        .get(url, configObject.authConfig())
        .then((response) => {
          this.settlementAcct = response.data;
          this.showLoader = false;
          // grid.ej2Instances.setProperties({ dataSource: response.data });
          // this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },

    getCompanyBalance() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Pos/CompanyBalance/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          configObject.authConfig()
        )
        .then((response) => {
          this.companyBalance = this.convertThousand(response.data.balance);
        })
        .catch((error) => {});
    },

    getVendors() {
      this.axios
        .get(
          `${configObject.posBaseUrl}/POS/GetVendors`,
          configObject.remisConfig()
        )
        .then((response) => {
          response.data.sort((a, b) => {
            return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
          });
          this.vendors = response.data;
        })
        .catch((error) => {});
    },

    handleNextPage() {
      this.newToken = this.continuationToken;
      this.pages++;
      this.getTransactions();
    },
    handlePreviousPage() {
      // this.newToken = this.previousToken;
      this.newToken = "";
      // this.pages--;
      this.pages = 1;
      this.getTransactions();
    },

    getTransactions() {
      this.showLoader = true;

      const status = this.status == "selectAStatus" ? "" : this.status;
      const vendor = this.vendor === "selectVendor" ? " " : this.vendor;

      let url = `${configObject.apiBaseUrl}/v2/POS/Entity/Transactions/${
        this.$route.query.companyId
          ? this.$route.query.companyId
          : this.company.id
      }/company?startDate=${this.$route.query.startDate}&endDate=${
        this.$route.query.endDate
      }&continuationToken=${
        this.continuationToken
      }&status=${status}&vendor=${vendor}`;

      this.axios
        .get(url, configObject.remisConfig())
        .then((response) => {
          let index = 0;
          this.continuationToken = response.data.data.continuationToken;
          this.previousToken = response.data.data.prevContinuationToken;

          response.data.data.transactions.forEach((cur) => {
            cur.index = ++index;
          });

          this.showLoader = false;

          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data.data.transactions,
          });
          this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },

    getPOSSummary() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/v2/POS/Entity/Summary/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }/company?startDate=${this.$route.query.startDate}&endDate=${
            this.$route.query.endDate
          }`,
          configObject.remisConfig()
        )
        .then((response) => {
          this.totalTransactionsAmount = response.data.data.allSales;
          this.totalSuccessfulTransactionsAmount =
            response.data.data.successfulSales;
          this.totalFailedTransactionsAmount = response.data.data.failedSales;
          this.totalTransactions = response.data.data.allCount;
          this.totalSuccessfulTransactions = response.data.data.successfulCount;
          this.totalFailedTransactions = response.data.data.failedCount;
        })
        .catch((error) => {});
    },
  },
};
</script>
<style>
.e-grid .e-row:hover .e-rowcell {
  cursor: pointer;
}

.cursor-not-allowed {
  cursor: not-allowed !important;
}

@media screen and (max-width: 602px) {
  .POSModal .v--modal-box.v--modal {
    margin: 0 auto;
    top: 112px !important;
    width: 90% !important;
    height: 500px !important;
    left: 0 !important;
    overflow: auto;
  }
  .POSModal .v--modal-box.v--modal {
    margin: 0 auto;
    /* top: 88px !important; */
    width: 90% !important;
    height: 379px !important;
    left: 0 !important;
    overflow: auto;
  }
  button.add_quick_fuel_btn {
    margin-bottom: 62px;
  }
}
</style>
